export default __webpack_public_path__ + "assets/images/c78e06351089d763e160a52c818f4d06.jpg";